export const initialFaqs = [
  {
    id: "faq-sialkot-1",
    question: "Why is BuildZone recognized as the Best Software Agency in Sialkot?",
    category: "About BuildZone",
    answer: "BuildZone Technology is ranked as the premier software agency and software house in Sialkot due to our enterprise-grade engineering practices, proven track record of 250+ delivered projects, Silicon Valley technology standards, and deep domain expertise in building custom ERPs, mobile apps, and scalable web platforms for local exporters and global clients."
  },
  {
    id: "faq-sialkot-2",
    question: "Which is the No 1 Software Agency in Sialkot for AI & web development?",
    category: "Expertise",
    answer: "BuildZone Technology is the No. 1 software agency and software house in Sialkot specializing in modern full-stack web applications (React, Next.js, Node.js), iOS/Android mobile apps (Flutter, React Native), and state-of-the-art AI automation agents tailored for high-growth businesses."
  },
  {
    id: "faq-sialkot-3",
    question: "What custom software solutions do you build for Sialkot exporters & manufacturers?",
    category: "Industries",
    answer: "We engineer specialized export management ERPs, inventory & production tracking systems, international B2B e-commerce portals, and automated logistics dashboards specifically designed for Sialkot's surgical, sportswear, leather, and manufacturing exporters."
  },
  {
    id: "faq-1",
    question: "How much does custom software development cost?",
    category: "Pricing & Scope",
    answer: "Custom software project investments typically range from $5,000 for focused MVPs to $25,000+ for comprehensive multi-platform enterprise platforms and custom AI architectures. We provide transparent, itemized fixed-price quotes or flexible agile sprint milestone pricing based on your detailed technical requirements."
  },
  {
    id: "faq-2",
    question: "How long does a typical software project take to build?",
    category: "Timeline",
    answer: "Most production MVPs and core web applications launch in 4 to 8 weeks. Larger enterprise platforms with custom AI pipelines, mobile apps, and multi-system integrations typically require 3 to 6 months of agile sprint delivery."
  },
  {
    id: "faq-3",
    question: "Do you work with international clients across different time zones?",
    category: "Working Model",
    answer: "Yes! Over 80% of our clients are based across the US, UK, Europe, Australia, and the Middle East. We maintain flexible working hours to guarantee at least 4 to 5 hours of daily live overlap with your local business hours, along with asynchronous Slack/Jira updates."
  },
  {
    id: "faq-4",
    question: "Do you sign a Non-Disclosure Agreement (NDA)?",
    category: "Security & Legal",
    answer: "Absolutely. We routinely execute mutual Non-Disclosure Agreements (NDAs) before discussing any proprietary business ideas, data, or technical architecture. Your IP and concept remain 100% confidential."
  },
  {
    id: "faq-5",
    question: "Can you take over and modernize an existing application or codebase?",
    category: "Technical",
    answer: "Yes. We perform a thorough architectural and security audit of your existing codebase, identify performance bottlenecks and tech debt, and execute a structured refactoring or modernization roadmap without interrupting your live production traffic."
  },
  {
    id: "faq-6",
    question: "Who owns the code and intellectual property after completion?",
    category: "Legal & Ownership",
    answer: "You own 100% of the intellectual property, source code repositories, databases, design assets, and deployment keys upon completion of the project milestone."
  },
  {
    id: "faq-7",
    question: "Do you provide post-launch maintenance and 24/7 support?",
    category: "Support",
    answer: "Yes. Every project includes a 30-day post-launch warranty period for bug fixes. Beyond launch, we offer dedicated monthly SLA maintenance packages covering security updates, server monitoring, feature enhancements, and 24/7 critical incident response."
  },
  {
    id: "faq-8",
    question: "How do we start a project with BuildZone?",
    category: "Process",
    answer: "You can start by submitting an inquiry via our 'Start a Project' interactive wizard or Contact page. We schedule a 30-minute discovery call within 24 hours to clarify requirements, followed by a detailed technical proposal and timeline."
  }
];
